import { render, staticRenderFns } from "./additional_info.vue?vue&type=template&id=4befa34c&"
import script from "./additional_info.vue?vue&type=script&lang=js&"
export * from "./additional_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports